import { Container, Sprite, Spritesheet } from 'pixi.js';

import { createPlayerOverlayContainer } from './player.helper';

export class GroupActivityOverlay {
  private _overlay: Container;
  public constructor(diameter: number, sprites: Spritesheet) {
    this._overlay = createPlayerOverlayContainer(sprites, { diameter, spriteName: 'group-activity-overlay' });
    this._overlay.visible = false;
    if (!sprites.textures) {
      return;
    }
    const icon = Sprite.from(sprites.textures['group-activity.svg']);
    icon.anchor.set(0.5, 0.5);
    icon.position.set(0, 0);
    icon.alpha = 0.8;
    this._overlay.addChild(icon);
  }

  public get overlay(): Container {
    return this._overlay;
  }

  public set visible(value: boolean) {
    this._overlay.visible = value;
  }
}
